import { getEntityRef } from "@client/content/lib/helper";
import { type EntityRef } from "@client/types";
import * as React from "react";
import Sections from "../Modules/container";
import { type CourseDetail } from "../types";

import "./style.less";

export type MapProps = EntityRef & {
  navigationType: CourseDetail.View.NavigatonType;
  style: React.CSSProperties;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Sections {...getEntityRef(props)} navigationType={props.navigationType} style={props.style} />
);
